/**
 * The heading both app pages share: My apps (/apps) and the catalog
 * (/apps/catalog), two addresses with a switch between them.
 */
import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { Eyebrow } from './components/primitives';

const PAGES = [
  { to: '/apps', label: 'My apps' },
  { to: '/apps/catalog', label: 'Catalog' },
] as const;

export function AppsNav({ title, lede, children }: { title: string; lede: ReactNode; children?: ReactNode }) {
  return (
    <header>
      <Eyebrow>Priorities.ai · Apps</Eyebrow>
      <div className="mt-2 flex flex-wrap items-end justify-between gap-3">
        <div className="min-w-0">
          <h1 className="font-heading font-semibold text-2xl text-[var(--text-pri)]">{title}</h1>
          <p className="mt-1 max-w-lg font-body text-sm text-[var(--text-sec)]">{lede}</p>
        </div>
        <nav aria-label="Apps" className="flex shrink-0 border border-[var(--rule)]">
          {PAGES.map((page) => (
            <NavLink
              key={page.to}
              to={page.to}
              end
              className={({ isActive }) =>
                `px-3 py-1.5 font-body text-sm ${
                  isActive
                    ? 'bg-[var(--bg-raised)] font-medium text-[var(--text-pri)]'
                    : 'text-[var(--text-sec)] hover:bg-[var(--hover-tint)]'
                }`
              }
            >
              {page.label}
            </NavLink>
          ))}
        </nav>
      </div>
      {children}
    </header>
  );
}
